var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 104",
    style: {
      enableBackground: "new 0 0 104 104"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st123{fill:#D7DBE7;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M103.2,50L87.9,34.7c4.4-2.2,7.4-6.8,7.4-12c0-7.4-6-13.4-13.4-13.4c-5.2,0-9.7,3-12,7.4L54.2,1 c-1.2-1.2-3.1-1.2-4.3,0L35.3,15.6c-2.4-3.8-6.6-6.3-11.4-6.3c-7.4,0-13.4,6-13.4,13.4c0,4.8,2.5,9,6.3,11.4L0.9,50 c-1.2,1.2-1.2,3.1,0,4.3l49,49c0.6,0.6,1.4,0.9,2.1,0.9s1.5-0.3,2.1-0.9l17.9-17.9c0.7-0.7,1-1.7,0.8-2.7c-0.2-1-0.8-1.8-1.7-2.2 c-2.6-1.2-4.3-3.8-4.3-6.7c0-4.1,3.3-7.4,7.4-7.4c2.9,0,5.5,1.7,6.7,4.3c0.4,0.9,1.2,1.5,2.2,1.7c1,0.2,2-0.1,2.7-0.8l17.2-17.2 c0.6-0.6,0.9-1.3,0.9-2.1S103.7,50.6,103.2,50z M84.2,64.7c-2.5-2.7-6.1-4.4-9.9-4.4c-7.4,0-13.4,6-13.4,13.4c0,3.8,1.6,7.4,4.4,9.9 L52.1,96.8L7.4,52.1l17-17c0.8-0.8,1.1-2,0.7-3.1c-0.3-1.1-1.3-1.9-2.4-2.1c-3.6-0.6-6.2-3.7-6.2-7.3c0-4.1,3.3-7.4,7.4-7.4 c3.6,0,6.7,2.6,7.3,6.2c0.2,1.1,1,2,2.1,2.4c1.1,0.3,2.3,0.1,3.1-0.7L52.1,7.4l17.2,17.2c0.9,0.9,2.1,1.1,3.3,0.7 c1.1-0.5,1.9-1.5,1.9-2.7c0.1-4,3.4-7.2,7.4-7.2c4.1,0,7.4,3.3,7.4,7.4c0,4-3.2,7.3-7.2,7.4c-1.2,0-2.3,0.8-2.7,1.9 c-0.5,1.1-0.2,2.4,0.7,3.3l16.8,16.8L84.2,64.7z M38.8,42.9c0.6,0,1.2-0.2,1.7-0.7l11.2-11c1-0.9,1-2.5,0-3.4c-0.9-1-2.5-1-3.4,0 l-11.2,11c-1,0.9-1,2.5,0,3.4C37.5,42.7,38.1,42.9,38.8,42.9z M58.3,38.2L34.6,61c-1,0.9-1,2.5-0.1,3.4c0.5,0.5,1.1,0.7,1.7,0.7 c0.6,0,1.2-0.2,1.7-0.7l23.7-22.8c1-0.9,1-2.5,0.1-3.4C60.8,37.3,59.3,37.2,58.3,38.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeam);
export default __webpack_public_path__ + "static/media/noTeam.eec3760d.svg";
export { ForwardRef as ReactComponent };